function genOAuth() {
  console.log("window.runConfig:")
  console.log(window.runConfig)
  if (window.runConfig) {
    var conf = {}
    conf[window.runConfig.envName] = window.runConfig
    return conf
  }
  else {
    return  {
      local: {
        userPoolId: 'us-east-2_csJtMSfdl',
        userPoolWebClientId: '7a1tpc1t2mu9e8ehqgjb63o6v1',
      },
      development: {
        userPoolId: 'us-east-2_csJtMSfdl',
        userPoolWebClientId: '7a1tpc1t2mu9e8ehqgjb63o6v1',
      },
      production: {
        userPoolId: 'us-east-2_MEsQ2E1s7',
        userPoolWebClientId: '4ua5mp3rsio43atq8kjebasm2e',
      },
    }
  }
}

export const OAUTH = genOAuth();
